import { QR_CODE_STATUS, QR_PANEL_STATUS } from './constants'
import type { QrCodeStatus } from './constants'
import type { QrPanelState, QrTerminalStatus } from './types'

export const isWaitingStatus = (status: QrPanelState['status']) =>
  status === QR_PANEL_STATUS.ACTIVE || status === QR_PANEL_STATUS.SCANNED

export const isCancelableStatus = (status: QrPanelState['status']) =>
  status === QR_PANEL_STATUS.ACTIVE ||
  status === QR_PANEL_STATUS.SCANNED ||
  status === QR_PANEL_STATUS.STARTING

export const isTerminalStatus = (
  status: QrPanelState['status']
): status is QrTerminalStatus =>
  status === QR_PANEL_STATUS.EXPIRED ||
  status === QR_PANEL_STATUS.DENIED ||
  status === QR_PANEL_STATUS.CANCELED ||
  status === QR_PANEL_STATUS.ERROR

export const getTerminalStatus = (
  status: QrPanelState['status']
): QrTerminalStatus | null => (isTerminalStatus(status) ? status : null)

export const toQrCodeStatus = (
  status: QrPanelState['status']
): QrCodeStatus => {
  if (status === QR_PANEL_STATUS.STARTING) return QR_CODE_STATUS.LOADING
  if (status === QR_PANEL_STATUS.SCANNED) return QR_CODE_STATUS.SCANNED
  if (isTerminalStatus(status)) return QR_CODE_STATUS.EXPIRED
  return QR_CODE_STATUS.ACTIVE
}

export const getStartBody = (domainName?: string) =>
  domainName ? { domain_name: domainName } : {}
